/**
 * Tabs
 *
 * Auto-initializes tab switching for any element with a data-tabs attribute.
 * Panels must have id="{tabsContainerId}-panel-{tabId}".
 */

function initTabs(tabsContainer: HTMLElement): void {
	const tabButtons = tabsContainer.querySelectorAll<HTMLElement>('[role="tab"]');
	const select = tabsContainer.querySelector<HTMLSelectElement>('[data-tabs-select]');
	const panelIds = Array.from(tabButtons)
		.map((tab) => tab.getAttribute('aria-controls'))
		.filter(Boolean) as string[];

	function getPanel(id: string): HTMLElement | null {
		return document.getElementById(id);
	}

	function switchTab(tabId: string): void {
		tabButtons.forEach((tab) => {
			const isActive = tab.dataset.tabId === tabId;
			tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
			tab.classList.toggle('bg-white', isActive);
			tab.classList.toggle('text-hh-navy', isActive);
			tab.classList.toggle('shadow-sm', isActive);
			tab.classList.toggle('text-text-secondary', !isActive);
			tab.classList.toggle('hover:text-text-primary', !isActive);
			tab.classList.toggle('hover:bg-white/50', !isActive);

			const badge = tab.querySelector('span');
			if (badge) {
				badge.classList.toggle('bg-hh-navy/10', isActive);
				badge.classList.toggle('text-hh-navy', isActive);
				badge.classList.toggle('bg-gray-100', !isActive);
				badge.classList.toggle('text-text-secondary', !isActive);
			}
		});

		if (select) {
			select.value = tabId;
		}

		panelIds.forEach((panelId) => {
			const panel = getPanel(panelId);
			if (panel) {
				const expectedId = `${tabsContainer.id}-panel-${tabId}`;
				panel.classList.toggle('hidden', panel.id !== expectedId);
			}
		});
	}

	tabButtons.forEach((tab) => {
		tab.addEventListener('click', (e) => {
			e.preventDefault();
			const tabId = tab.dataset.tabId;
			if (tabId) switchTab(tabId);
		});
	});

	if (select) {
		select.addEventListener('change', (e) => switchTab((e.target as HTMLSelectElement).value));
	}
}

export function initAllTabs(): void {
	document.querySelectorAll<HTMLElement>('[data-tabs]').forEach(initTabs);
}
